<template>
  <div
    v-if="currentTab !== null"
    class="ui padded grid">

    <div
      v-if="userLang === 'en'"
      class="sixteen wide column">
      <div
        class="ui two item top fixed inverted secondary pointing menu"
        style="border: none; background: #263d4b !important;">
        <a
          v-for="(tab, index) in tabList"
          :key="index"
          :class="{ active : tab.name === currentTab.name }"
          class="item"
          @touchend="updateTab(tab)"
          v-html="tab.name"/>
      </div>
    </div>
    <br>
    <br>

    <div class="sixteen wide column">
      <transition
        name="fade"
        mode="out-in">
        <keep-alive>
          <component :is="currentTab.component"/>
        </keep-alive>
      </transition>
    </div>

    <br>
    <br>
  </div>
</template>

<script>
import GroupTab from './GroupTab.vue';
import IndividualTab from './IndividualTab';

export default {
  name: 'Home',
  components: {
    GroupTab,
    IndividualTab
  },
  props: {
    initialTab: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      tabList: [{
        name: 'Me', // TODO: this should be reading from localization.something
        component: IndividualTab
      }, {
        name: `Trend&nbsp;<sup>BETA</sup>`, // TODO: this should be reading from localization.something
        component: GroupTab
      }],
      currentTab: null
    };
  },
  mounted () {
    this.currentTab = this.tabList[this.initialTab];
  },
  methods: {
    updateTab (tab) {
      this.currentTab = tab;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue